import React from 'react';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { useSetLensArchived } from '~/hooks/apis/reporting/useLensArchive';

import type { Lens } from '~/types/leLens';

export default function LensArchiveDialog({ lens, onClose }: { lens: Lens | null; onClose: () => void }) {
  const mutation = useSetLensArchived();
  return (
    <Dialog
      open={Boolean(lens)}
      onClose={mutation.isPending ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="archive-lens-title"
      PaperProps={{ sx: { borderRadius: '8px' } }}
    >
      <DialogTitle id="archive-lens-title">Archive “{lens?.title}”?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          It will leave active shelves, recent Lenses and everyone’s pins. Scheduled emails will be paused.
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          The definition, sharing and version history are kept. Existing links show an archived notice. You can restore
          it from Archived in My Lenses.
        </DialogContentText>
        {mutation.isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {mutation.error.message || 'Could not archive this Lens. Retry.'}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={mutation.isPending} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={mutation.isPending}
          onClick={() => lens && mutation.mutate({ lens, archived: true }, { onSuccess: onClose })}
        >
          {mutation.isPending ? 'Archiving…' : 'Archive Lens'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
